import { useTranslation } from "react-i18next";
import type { WebsiteIssue } from "../../content/issues";
import { IssueCard } from "./IssueCard";

interface FolderSectionProps {
  folder: string;
  issues: WebsiteIssue[];
}

export function FolderSection({ folder, issues }: FolderSectionProps) {
  const { t } = useTranslation();
  const anchorId = folder ? `folder-${folder}` : "folder-root";
  const displayName = folder
    ? folder.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : t('common.folderGeneral');

  return (
    <section id={anchorId} className="scroll-mt-20">
      <div className="flex items-center gap-3 mb-6">
        <h2 className="text-2xl font-bold text-warm-50">{displayName}</h2>
        <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-warm-500/20 text-warm-400 border border-warm-500/30">
          {issues.length}
        </span>
      </div>

      <div className="space-y-4">
        {issues.map((issue) => (
          <IssueCard key={issue.id} issue={issue} />
        ))}
      </div>
    </section>
  );
}
